document.querySelectorAll('.category-card-row-slider .ccr-slider.swiper').forEach(function (el) {
  if (el.dataset.sliderInitialized === 'true') return;

  var validCards = parseInt(el.dataset.validCards || '0', 10);
  if (!validCards) return;

  el.dataset.sliderInitialized = 'true';

  var gapMobile = parseFloat(el.dataset.gapMobile || '0') || 0;
  var gapTablet = parseFloat(el.dataset.gapTablet || '0') || gapMobile;
  var gapDesktop = parseFloat(el.dataset.gapDesktop || '0') || gapTablet;

  var swiper = new Swiper(el, {
    slidesPerView: 'auto',
    spaceBetween: gapMobile,
    grabCursor: true,
    watchOverflow: false,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    freeMode: {
      enabled: true,
      sticky: false,
      momentum: true,
    },
    keyboard: { enabled: true },
    breakpoints: {
      750: { spaceBetween: gapTablet },
      1024: { spaceBetween: gapDesktop },
    },
    scrollbar: {
      el: el.querySelector('.ccr-swiper-scrollbar'),
      draggable: true,
      hide: false,
    },
  });

  var sync = function () {
    swiper.updateSlides();
    swiper.updateSize();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    if (swiper.scrollbar && swiper.scrollbar.updateSize) swiper.scrollbar.updateSize();

    var bar = el.querySelector('.ccr-swiper-scrollbar');
    if (bar) bar.style.display = 'flex';
  };

  window.addEventListener('load', sync);
  window.addEventListener('resize', sync);
  setTimeout(sync, 0);
  setTimeout(sync, 150);
});

(function () {
  var dragThreshold = 5;

  function getPoint(event) {
    var source = event.touches ? event.touches[0] : event.changedTouches ? event.changedTouches[0] : event;

    return {
      x: source.pageX,
      y: source.pageY,
    };
  }

  function initCategoryCardDragFix(slider) {
    if (slider.dataset.categoryCardDragFixInitialized === 'true') return;

    var row = slider.querySelector('.ccr-row.scroll-x-draggable');
    if (!row) return;

    slider.dataset.categoryCardDragFixInitialized = 'true';

    var isPointerDown = false;
    var didDrag = false;
    var startX = 0;
    var startY = 0;

    function handleStart(event) {
      if (event.button !== undefined && event.button !== 0) return;

      var point = getPoint(event);
      isPointerDown = true;
      didDrag = false;
      startX = point.x;
      startY = point.y;
    }

    function handleMove(event) {
      if (!isPointerDown) return;

      var point = getPoint(event);
      var deltaX = Math.abs(point.x - startX);
      var deltaY = Math.abs(point.y - startY);

      if (deltaX > deltaY && deltaX > dragThreshold) {
        didDrag = true;
      }
    }

    function handleEnd() {
      if (isPointerDown) {
        row.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
      }

      isPointerDown = false;
    }

    row.addEventListener('mousedown', handleStart, true);
    row.addEventListener('touchstart', handleStart, { capture: true, passive: true });
    row.addEventListener('dragstart', function (event) {
      event.preventDefault();
    }, true);

    document.addEventListener('mousemove', handleMove, true);
    document.addEventListener('touchmove', handleMove, { capture: true, passive: true });
    document.addEventListener('mouseup', handleEnd, true);
    document.addEventListener('touchend', handleEnd, true);
    document.addEventListener('touchcancel', handleEnd, true);
    window.addEventListener('blur', handleEnd);

    row.addEventListener('click', function (event) {
      if (!didDrag) return;

      event.preventDefault();
      event.stopPropagation();
      didDrag = false;
    }, true);
  }

  document.querySelectorAll('.category-card-row-slider .ccr-slider').forEach(initCategoryCardDragFix);
})();

(function () {
  function initCategoryScrollbar(slider) {
    if (slider.dataset.categoryScrollbarInitialized === 'true') return;

    var row = slider.querySelector('.ccr-row.scroll-x-draggable');
    var scrollbar = slider.querySelector('.ccr-scrollbar');
    var thumb = scrollbar ? scrollbar.querySelector('.ccr-scrollbar-thumb') : null;

    if (!row || !scrollbar || !thumb) return;

    slider.dataset.categoryScrollbarInitialized = 'true';

    var isDraggingThumb = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;

    function getClientX(event) {
      var source = event.touches ? event.touches[0] : event.changedTouches ? event.changedTouches[0] : event;
      return source.clientX;
    }

    function applyVisibleScrollbarStyles() {
      scrollbar.style.display = 'block';
      scrollbar.style.position = 'relative';
      scrollbar.style.width = '100%';
      scrollbar.style.height = '12px';
      scrollbar.style.marginTop = '12px';
      scrollbar.style.borderRadius = '50px';
      scrollbar.style.background = '#e0e0e0';
      scrollbar.style.opacity = '1';
      scrollbar.style.visibility = 'visible';
      scrollbar.style.zIndex = '2';

      thumb.style.display = 'block';
      thumb.style.position = 'absolute';
      thumb.style.top = '0';
      thumb.style.left = '0';
      thumb.style.height = '100%';
      thumb.style.minWidth = '44px';
      thumb.style.borderRadius = 'inherit';
      thumb.style.background = '#555555';
      thumb.style.opacity = '1';
      thumb.style.visibility = 'visible';
    }

    function updateScrollbar() {
      applyVisibleScrollbarStyles();

      var maxScrollLeft = row.scrollWidth - row.clientWidth;

      if (maxScrollLeft <= 0) {
        scrollbar.classList.add('is-visible');
        thumb.style.width = '100%';
        thumb.style.transform = 'translateX(0)';
        return;
      }

      var scrollbarWidth = scrollbar.clientWidth;
      var thumbWidth = Math.max((row.clientWidth / row.scrollWidth) * scrollbarWidth, 44);
      var maxThumbOffset = scrollbarWidth - thumbWidth;
      var thumbOffset = maxThumbOffset * (row.scrollLeft / maxScrollLeft);

      scrollbar.classList.add('is-visible');
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + thumbOffset + 'px)';
    }

    function scrollFromTrackPosition(clientX) {
      var rect = scrollbar.getBoundingClientRect();
      var thumbWidth = thumb.offsetWidth;
      var maxThumbOffset = scrollbar.clientWidth - thumbWidth;
      var maxScrollLeft = row.scrollWidth - row.clientWidth;
      var targetThumbOffset = clientX - rect.left - thumbWidth / 2;
      var boundedThumbOffset = Math.max(0, Math.min(targetThumbOffset, maxThumbOffset));

      row.scrollLeft = maxThumbOffset > 0 ? (boundedThumbOffset / maxThumbOffset) * maxScrollLeft : 0;
    }

    function handleThumbStart(event) {
      event.preventDefault();
      isDraggingThumb = true;
      dragStartX = getClientX(event);
      dragStartScrollLeft = row.scrollLeft;
      scrollbar.classList.add('is-dragging');
    }

    function handleTrackStart(event) {
      if (event.target === thumb) return;

      event.preventDefault();
      scrollFromTrackPosition(getClientX(event));
      handleThumbStart(event);
    }

    function handleMove(event) {
      if (!isDraggingThumb) return;

      event.preventDefault();

      var maxScrollLeft = row.scrollWidth - row.clientWidth;
      var maxThumbOffset = scrollbar.clientWidth - thumb.offsetWidth;
      var deltaX = getClientX(event) - dragStartX;
      var scrollDelta = maxThumbOffset > 0 ? (deltaX / maxThumbOffset) * maxScrollLeft : 0;

      row.scrollLeft = dragStartScrollLeft + scrollDelta;
    }

    function handleEnd() {
      isDraggingThumb = false;
      scrollbar.classList.remove('is-dragging');
    }

    row.addEventListener('scroll', updateScrollbar, { passive: true });
    thumb.addEventListener('mousedown', handleThumbStart);
    thumb.addEventListener('touchstart', handleThumbStart, { passive: false });
    scrollbar.addEventListener('mousedown', handleTrackStart);
    scrollbar.addEventListener('touchstart', handleTrackStart, { passive: false });
    document.addEventListener('mousemove', handleMove);
    document.addEventListener('touchmove', handleMove, { passive: false });
    document.addEventListener('mouseup', handleEnd);
    document.addEventListener('touchend', handleEnd);
    document.addEventListener('touchcancel', handleEnd);
    window.addEventListener('resize', updateScrollbar);
    window.addEventListener('load', updateScrollbar);

    updateScrollbar();
    setTimeout(updateScrollbar, 150);
  }

  document.querySelectorAll('.category-card-row-slider .ccr-slider').forEach(initCategoryScrollbar);
})();